var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiCircleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 126,
    viewBox: "0 0 113 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-65 89.114C-65 39.9607 -25.1533 0.114014 24 0.114014C73.1533 0.114014 113 39.9607 113 89.114V117.302C113 121.616 109.502 125.114 105.188 125.114H-57.1875C-61.5022 125.114 -65 121.616 -65 117.302V89.114Z",
    fill: "#005964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiCircleMobile);
export default __webpack_public_path__ + "static/media/semi-circle-mobile.303bace216e23b1166e3c72cd006f711.svg";
export { ForwardRef as ReactComponent };